
import { CoordinatesPosition } from '@/utils/models';
import { Component, Inject, InjectReactive, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class ToolBarItem extends Vue {
  @InjectReactive('selectedValue') selectedValue!: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: '' }) value!: string;
  @Prop({ default: '' }) title!: string;
  onClick() {
    this.selectItem(this.value, this.title);
  }

  @Inject() selectItem!: (value: string, title: string) => void;

  getToolBarItemRect(): Pick<DOMRect, 'x' | 'y' | 'width' | 'height'> {
    const ref = this.$refs.wrapper as HTMLElement;
    if (!ref) return { x: 0, y: 0, width: 0, height: 0 };
    const rect = ref.getBoundingClientRect();
    return {
      x: rect.left,
      y: rect.top + rect.height,
      width: rect.width,
      height: rect.height,
    };
  }
}
